<template>
  <div class="bj">
    <div class="actual-content">
        <div class="actual-date">
          <img src="../imgs/北京.png" />
          <span>{{ shijian }}</span>
        </div>
        <div class="actual-sm">(除城区为官园区域站其它站点均为国家站)</div>
        <div class="actual-map">
          <div class="ditu"></div>
          <div class="h-r-case utils-case">
            <span>怀柔</span>
            <i>{{ hrt }}</i>
          </div>
          <p class="p1"><img src="../imgs/1.png" alt="" /></p>
          <div class="m-y-case utils-case">
            <span>密云</span>
            <i>{{ myt }}</i>
          </div>
          <p class="p2"><img src="../imgs/1.png" alt="" /></p>
          <div class="y-q-case utils-case">
            <span>延庆</span>
            <i>{{ yqt }}</i>
          </div>
          <p class="p3"><img src="../imgs/1.png" alt="" /></p>
          <div class="c-p-case utils-case">
            <span>昌平</span>
            <i>{{ cpt }}</i>
          </div>
          <p class="p4"><img src="../imgs/1.png" alt="" /></p>
          <div class="s-y-case utils-case">
            <span>顺义</span>
            <i>{{ syt }}</i>
          </div>
          <p class="p5"><img src="../imgs/1.png" alt="" /></p>
          <div class="p-g-case utils-case">
            <span>平谷</span>
            <i>{{ pgt }}</i>
          </div>
          <p class="p6"><img src="../imgs/1.png" alt="" /></p>
          <div class="m-t-g-case utils-case">
            <span>门头沟</span>
            <i>{{ mtgt }}</i>
          </div>
          <p class="p7"><img src="../imgs/1.png" alt="" /></p>
          <div class="s-j-s-case utils-case">
            <span>石景山</span>
            <i>{{ sjst }}</i>
          </div>
          <p class="p8"><img src="../imgs/1.png" alt="" /></p>
          <div class="h-d-case utils-case">
            <span>海淀</span>
            <i>{{ hdt }}</i>
          </div>
          <p class="p9"><img src="../imgs/1.png" alt="" /></p>
          <div class="c-y-case utils-case">
            <span>朝阳</span>
            <i>{{ cyt }}</i>
          </div>
          <p class="p10"><img src="../imgs/1.png" alt="" /></p>
          <div class="t-z-case utils-case">
            <span>通州</span>
            <i>{{ tzt }}</i>
          </div>
          <p class="p11"><img src="../imgs/1.png" alt="" /></p>
          <div class="f-t-case utils-case">
            <span>丰台</span>
            <i>{{ ftt }}</i>
          </div>
          <p class="p12"><img src="../imgs/1.png" alt="" /></p>
          <div class="f-s-case utils-case">
            <span>房山</span>
            <i>{{ fst }}</i>
          </div>
          <p class="p13"><img src="../imgs/1.png" alt="" /></p>
          <div class="d-x-case utils-case">
            <span>大兴</span>
            <i>{{ dxt }}</i>
          </div>
          <p class="p14"><img src="../imgs/1.png" alt="" /></p>
          <div class="c-q-case utils-case">
            <span>城区</span>
            <i>{{ cqt }}</i>
          </div>
          <p class="p15"><img src="../imgs/1.png" alt="" /></p>
        </div>
        <!-- <div class="actual-unit"></div> -->
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      hrt: "",
      myt: "",
      yqt: "",
      cpt: "",
      syt: "",
      pgt: "",
      mtgt: "",
      sjst: "",
      hdt: "",
      cyt: "",
      tzt: "",
      ftt: "",
      fst: "",
      dxt: "",
      cqt: "",
      shijian: "",
    };
  },
  mounted() {
    this.require();
  },
  methods: {
    require() {
      axios.get("/data/bj/tempData.json").then((res) => {
        var time = res.data.data[0].reqInfo.requestTime;
        this.shijian =
          moment(time, "YYYY-MM-DD HH:mm:ss").format("YYYY") +
          "年" +
          moment(time, "YYYY-MM-DD HH:mm:ss").format("MM") +
          "月" +
          moment(time, "YYYY-MM-DD HH:mm:ss").format("DD") +
          "日" +
          " " +
          moment(time, "YYYY-MM-DD HH:mm:ss").format("HH") +
          "时" +
          " " +
          "温度(℃)";
        var ss = res.data.data[0].data;
        for (var i = 0; i < ss.length; i++) {
          if (ss[i][1] == 54419) {
            if(ss[i][2]!='9999'){
              this.hrt = ss[i][2];
            }else{
              this.hrt=''
            }
          } else if (ss[i][1] == 54416) {
            if(ss[i][2]!='9999'){
              this.myt = ss[i][2];
            }else{
              this.myt=''
            }
          } else if (ss[i][1] == 54406) {
            if(ss[i][2]!='9999'){
               this.yqt = ss[i][2];
            }else{
              this.yqt=''
            }
          } else if (ss[i][1] == 54499) {
            if(ss[i][2]!='9999'){
              this.cpt = ss[i][2];
            }else{
              this.cpt=''
            }
          } else if (ss[i][1] == 54398) {
            if(ss[i][2]!='9999'){
              this.syt = ss[i][2];
            }else{
              this.syt=''
            }
          } else if (ss[i][1] == 54424) {
            if(ss[i][2]!='9999'){
              this.pgt = ss[i][2];
            }else{
              this.pgt=''
            }
          } else if (ss[i][1] == 54505) {
            if(ss[i][2]!='9999'){
              this.mtgt = ss[i][2];
            }else{
              this.mtgt=''
            }
          } else if (ss[i][1] == 54513) {
            if(ss[i][2]!='9999'){
              this.sjst = ss[i][2];
            }else{
              this.sjst=''
            }
          } else if (ss[i][1] == 651006) {
            if(ss[i][2]!='9999'){
              this.cqt = ss[i][2];
            }else{
              this.cqt=''
            }
          } else if (ss[i][1] == 54399) {
            if(ss[i][2]!='9999'){
              this.hdt = ss[i][2];
            }else{
              this.hdt=''
            }
          } else if (ss[i][1] == 54433) {
            if(ss[i][2]!='9999'){
              this.cyt = ss[i][2];
            }else{
              this.cyt=''
            }
          } else if (ss[i][1] == 54431) {
            if(ss[i][2]!='9999'){
              this.tzt = ss[i][2];
            }else{
              this.tzt=''
            }
          } else if (ss[i][1] == 54514) {
            if(ss[i][2]!='9999'){
              this.ftt = ss[i][2];
            }else{
              this.ftt=''
            }
          } else if (ss[i][1] == 54596) {
            if(ss[i][2]!='9999'){
              this.fst = ss[i][2];
            }else{
              this.fst=''
            }
          } else if (ss[i][1] == 54594) {
            if(ss[i][2]!='9999'){
              this.dxt = ss[i][2];
            }else{
              this.dxt=''
            }
          }
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bj {
  flex: 16;
  padding: 0 1% 18% 1%;
  display: flex;
  .actual-content {
      padding: 2px;
      flex: 1;
      box-shadow: 0 2px 2px 2px rgba(27, 27, 27, 0.1);
      background: url("../imgs/weatherbj.jpg") no-repeat;
      background-size: 100% 100%;
      overflow: hidden;
      position: relative;
      .actual-date {
        margin: 2% auto 0;
        width: 76%;
        height: 5.5%;
        align-items: center;
        display: flex;
        background: url("../imgs/actualdate.png") no-repeat;
        background-size: 100% 100%;
        img {
          height: 100%;
        }
        span {
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 26px;
          font-weight: 700;
          height: 100%;
          width: 100%;
          color: #0f286e;
        }
      }
      .actual-sm{
        font-size: 20px;
        position: absolute;
        right:2%;
        top:8%;
        color:#fff;
        text-shadow: 2px 2px 9px #000;
      }
      .actual-map {
        position: relative;
        width: 100%;
        height: 77%;
        top: 6%;
        background: url("../imgs/bjmap.png") no-repeat;
        background-size: 100% 100%;
        .ditu {
          z-index: 999;
          width: 100%;
          height: 100%;
          background: url("../imgs/北京地图线最上.png") no-repeat;
          background-size: 100% 100%;
        }
      }
      .actual-unit {
        position: absolute;
        bottom:2%;
        left:50%;
        transform: translate(-50%);
        width: 35%;
        height: 6%;
        background: url("../imgs/logo.png") no-repeat;
        background-size: 100% 100%;
      }
  }
  .actual-map {
    .utils-case {
      position: absolute;
      padding: 3px 10px 3px 10px;
      background-color: #80cfff;
      background-image: linear-gradient(0deg, #4cbcff 0%, #c9ebff 80%);
      border: 1px solid #80bdf1;
      box-shadow: 0px 2px 2px 1px #99979778;
      border-radius: 20px;
      display: flex;
      align-items: center;
      height: 40px;
      span {
        font-size: 20px;
        font-weight: 700;
        color: #00408e;
      }
      i {
        margin-left: 2px;
        font-size: 20px;
        font-weight: 700;
        color: #9b0000;
      }
    }
    .p1,
    .p2,
    .p3,
    .p4,
    .p5,
    .p6,
    .p7,
    .p8,
    .p9,
    .p10,
    .p11,
    .p12,
    .p13,
    .p14,
    .p15 {
      img {
        width: 18px;
        height: 12px;
      }
    }
    .h-r-case {
      top: 36%;
      left: 45%;
    }
    .p1 {
      position: absolute;
      display: flex;
      top: 41%;
      left: 55%;
    }
    .m-y-case {
      top: 33.6%;
      left: 65%;
    }
    .p2 {
      position: absolute;
      display: flex;
      top: 38.5%;
      left: 67.5%;
    }
    .y-q-case {
      top: 34%;
      left: 17%;
    }
    .p3 {
      position: absolute;
      display: flex;
      top: 39%;
      left: 21%;
    }
    .c-p-case {
      top: 47%;
      left: 28%;
    }
    .p4 {
      position: absolute;
      display: flex;
      top: 52%;
      left: 35%;
    }
    .s-y-case {
      top: 50%;
      left: 55%;
    }
    .p5 {
      position: absolute;
      display: flex;
      top: 55%;
      left: 56.8%;
    }
    .p-g-case {
      top: 44.5%;
      right: 4%;
    }
    .p6 {
      position: absolute;
      display: flex;
      top: 49%;
      left: 84%;
    }
    .m-t-g-case {
      top: 69.4%;
      right: 65%;
    }
    .p7 {
      position: absolute;
      display: flex;
      top: 71.2%;
      left: 34%;
      transform: rotate(-90deg);
    }
    .s-j-s-case {
      top: 64.4%;
      right: 63%;
    }
    .p8 {
      position: absolute;
      display: flex;
      top: 67.5%;
      left: 36%;
      transform: rotate(-60deg);
    }
    .h-d-case {
      top: 59.5%;
      right: 51%;
    }
    .p9 {
      position: absolute;
      display: flex;
      top: 64.5%;
      left: 40.3%;
    }
    .c-y-case {
      top: 58.5%;
      left: 50%;
    }
    .p10 {
      position: absolute;
      display: flex;
      top: 63.5%;
      left: 53%;
    }
    .t-z-case {
      top: 72.5%;
      left: 63%;
    }
    .p11 {
      position: absolute;
      display: flex;
      top: 71.2%;
      left: 67%;
      transform: rotate(184deg);
    }
    .f-t-case {
      top: 71.6%;
      left: 43%;
    }
    .p12 {
      position: absolute;
      display: flex;
      top: 73.3%;
      left: 41%;
      transform: rotate(90deg);
    }
    .f-s-case {
      top: 82%;
      left: 27%;
    }
    .p13 {
      position: absolute;
      display: flex;
      top: 80.5%;
      left: 38%;
      transform: rotate(184deg);
    }
    .d-x-case {
      top: 79.3%;
      left: 50%;
    }
    .p14 {
      position: absolute;
      display: flex;
      top: 81%;
      left: 48%;
      transform: rotate(90deg);
    } 
    .c-q-case {
      top: 66%;
      left: 52%;
    }
    .p15 {
      position: absolute;
      display: flex;
      top: 68%;
      left: 50%;
      transform: rotate(90deg);
    }
  }
}
</style>